import { resolveUTMDataRepository } from "@di/app";
import {
  DEFAULT_REFERRER,
  LOGIN_REDIRECT_TO_ANDROID,
  URLS,
} from "@features/shared/presentation";
import { isUserForceVerificationEnabled } from "@features/user/data";
import { trackRedirectToMobileApp } from "@features/user/data/activities";
import { NAVIGATING } from "@taager/react-router";
import { isMobile } from "@taager/supportive-is";
import { isUserCurrentlyRegistering } from "app/auth/utils";
import { navigate } from "app/utils";
import user from "user";
import { getMerchantHomeUrl } from "../../shared/utils";

/**
 * Use this middleware if the page requires the user to be logged in
 */
export function Guardian() {
  if (!user.isLoggedIn) {
    return navigate(URLS.auth.login);
  }
}

export function FullyVerifiedMerchant() {
  if (!isUserForceVerificationEnabled()) return;

  if (!user.isFullyVerified) {
    return navigate(URLS.auth.register);
  }
}

/**
 * Use this middleware if you want to redirect the user to the home page if he/she is logged in
 */
export function ReverseGuardian() {
  if (user.isLoggedIn && !isUserCurrentlyRegistering()) {
    return navigate(getMerchantHomeUrl());
  }
}

export function redirectToMobileApp() {
  const isAndroid = isMobile.android();

  if (!isAndroid) return null;

  trackRedirectToMobileApp("android");

  const utmData = resolveUTMDataRepository().getData();

  const utmParams = utmData ? new URLSearchParams(utmData).toString() : null;

  const queryParams = new URLSearchParams({
    referrer: utmParams || DEFAULT_REFERRER,
    source_url: encodeURIComponent(window.location.href),
  }).toString();

  window.location.replace(LOGIN_REDIRECT_TO_ANDROID + `&${queryParams}`);

  return NAVIGATING;
}
